/*
 * ngComboDatePicker v1.3.1
 * http://github.com/jfmdev/ngComboDatePicker
 * «Copyright 2015 Jose F. Maldonado»
 * This Source Code Form is subject to the terms of the Mozilla Public License, v. 2.0. If a copy of the MPL was not distributed with this file, You can obtain one at http://mozilla.org/MPL/2.0/.
 */
angular.module("ngComboDatePicker", []).directive("ngComboDatePicker", function() {
    function maxDate(a, b) {
        var c = 31;
        return null != a && (4 != a && 6 != a && 9 != a && 11 != a || (c = 30), null != b && 2 == a && (c = b % 4 == 0 && b % 100 != 0 ? 29 : 28)), c
    }

    function adjustTimezone(a, b) {
        var c = isNaN(b) ? (new Date).getTimezoneOffset() : 60 * parseFloat(b);
        return new Date(a.getTime() + 60 * c * 1e3)
    }

    function parseDate(a, b) {
        var c = null;
        return void 0 !== a && null !== a && (a instanceof Date ? c = a : "number" != typeof a && "string" != typeof a || (c = new Date(isNaN(a) ? a : parseInt(a, 10)), c = adjustTimezone(c, b))), c
    }

    function parseIntStrict(a) {
        return null !== a && "" !== a && NaN != parseInt(a) ? parseInt(a) : null
    }

    function parseJsonPlus(a) {
        var b = null;
        if (null != a) {
            try {
                b = JSON.parse(a)
            } catch (a) {}
            if (null == b) try {
                b = JSON.parse(a.replace(/'/g, '"'))
            } catch (a) {}
        }
        return b
    }
    return {
        restrict: "AEC",
        scope: {
            ngModel: "=",
            ngDate: "@",
            ngMinDate: "@",
            ngMaxDate: "@",
            ngMonths: "@",
            ngOrder: "@",
            ngAttrsDate: "@",
            ngAttrsMonth: "@",
            ngAttrsYear: "@",
            ngYearOrder: "@",
            ngTimezone: "@",
            ngPlaceholder: "@",
            ngRequired: "@"
        },
        require: "ngModel",
        controller: ["$scope", function(a) {
            a.ngModel = parseDate(a.ngModel, a.ngTimezone), a.ngAttrsDate = parseJsonPlus(a.ngAttrsDate), a.ngAttrsMonth = parseJsonPlus(a.ngAttrsMonth), a.ngAttrsYear = parseJsonPlus(a.ngAttrsYear);
            var b = parseDate(a.ngDate, a.ngTimezone);
            if (null != b && (a.ngModel = b), "string" != typeof a.ngOrder ? a.ngOrder = "dmy" : a.ngOrder = a.ngOrder.toLowerCase(), a.minDate = parseDate(a.ngMinDate, a.ngTimezone), null == a.ngMinDate) {
                var c = new Date;
                a.minDate = new Date(c.getFullYear() - 100, c.getMonth(), c.getDate(), c.getHours(), c.getMinutes(), c.getSeconds(), c.getMilliseconds())
            }
            if (a.maxDate = parseDate(a.ngMaxDate, a.ngTimezone), null == a.maxDate && (a.maxDate = new Date), a.ngModel < a.minDate && (a.ngModel = a.minDate), a.ngModel > a.maxDate && (a.ngModel = a.maxDate), a.placeHolders = null, void 0 !== a.ngPlaceholder && null !== a.ngPlaceholder && ("string" == typeof a.ngPlaceholder || Array.isArray(a.ngPlaceholder))) {
                var d = "string" == typeof a.ngPlaceholder ? a.ngPlaceholder.split(",") : a.ngPlaceholder;
                if (3 == d.length) {
                    a.placeHolders = [];
                    for (var e = 0; e < d.length; e++) a.placeHolders.push({
                        value: "",
                        name: d[e],
                        disabled: !1
                    })
                }
            }
            a.years = [];
            for (var f = a.minDate.getFullYear(); f <= a.maxDate.getFullYear(); f++) a.years.push({
                value: f,
                name: f
            });
            "string" == typeof a.ngYearOrder && 0 == a.ngYearOrder.indexOf("des") && a.years.reverse(), a.placeHolders && a.years.unshift(a.placeHolders[0]);
            var g = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            if (void 0 !== a.ngMonths && null !== a.ngMonths) {
                if ("string" == typeof a.ngMonths) {
                    var h = a.ngMonths.split(",");
                    12 == h.length && (g = h)
                }
                Array.isArray(a.ngMonths) && 12 == a.ngMonths.length && (g = a.ngMonths)
            }
            a.updateMonthList = function(b) {
                b = parseIntStrict(b);
                var c = null !== b && b == a.minDate.getFullYear() ? a.minDate.getMonth() : 0,
                    d = null !== b && b == a.maxDate.getFullYear() ? a.maxDate.getMonth() : 11;
                a.months = [], a.placeHolders && a.months.push(a.placeHolders[1]);
                for (var e = c; e <= d; e++) a.months.push({
                    value: e,
                    name: g[e]
                })
            }, a.updateDateList = function(b, c) {
                b = parseIntStrict(b), c = parseIntStrict(c);
                var d = 1;
                null !== b && b == a.minDate.getMonth() && null !== c && c == a.minDate.getFullYear() && (d = a.minDate.getDate());
                var e = maxDate(null !== b ? b + 1 : null, c);
                null !== b && b == a.maxDate.getMonth() && null !== c && c == a.maxDate.getFullYear() && (e = a.maxDate.getDate()), a.dates = [], a.placeHolders && a.dates.push(a.placeHolders[2]);
                for (var f = d; f <= e; f++) a.dates.push({
                    value: f,
                    name: f
                })
            }
        }],
        link: function(a, b, c, d) {
            for (var e = angular.element, f = e(b[0]).children(), g = a.ngOrder.split(""), h = 0; h < g.length; h++) "d" == g[h] && e(b[0]).append(f[0]), "m" == g[h] && e(b[0]).append(f[1]), "y" == g[h] && e(b[0]).append(f[2]);
            d.$formatters.push(function(b) {
                var c = {
                    date: null,
                    month: null,
                    year: null
                };
                return b ? (c.date = b.getDate(), c.month = b.getMonth(), c.year = b.getFullYear()) : (c.date = "", c.month = "", c.year = "", a.placeHolders && (a.placeHolders[0].disabled = !1, a.placeHolders[1].disabled = !1, a.placeHolders[2].disabled = !1)), a.updateMonthList(c.year), a.updateDateList(c.month, c.year), c
            }), d.$render = function() {
                a.date = d.$viewValue.date, a.month = d.$viewValue.month, a.year = d.$viewValue.year
            }, a.$watch('date + "-" + month + "-" + year', function(b, c) {
                b != c && d.$setViewValue({
                    date: a.date,
                    month: a.month,
                    year: a.year
                })
            }), d.$isEmpty = function(a) {
                return null == a.date || "" == a.date || isNaN(parseInt(a.month)) || null == a.year || "" == a.year
            }, d.$parsers.push(function(b) {
                var c = null;
                if (null != b.date && "" != b.date && !isNaN(parseInt(b.month)) && null != b.year && "" != b.year) {
                    var d = maxDate(b.month + 1, b.year),
                        e = 0,
                        f = 0,
                        g = 0,
                        h = 0;
                    null != a.ngModel && (e = a.ngModel.getHours(), f = a.ngModel.getMinutes(), g = a.ngModel.getSeconds(), h = a.ngModel.getMilliseconds()), c = new Date(b.year, b.month, b.date > d ? d : b.date, e, f, g, h)
                }
                return a.placeHolders && ("" != a.year && (a.placeHolders[0].disabled = !0), "" != a.month && (a.placeHolders[1].disabled = !0), "" != a.date && (a.placeHolders[2].disabled = !0)), a.updateMonthList(b.year), a.updateDateList(b.month, b.year), c
            })
        },
        template: function(element, attrs) {
            for (var strAttrs = ["", "", ""], attrNames = ["ngAttrsDate", "ngAttrsMonth", "ngAttrsYear"], i = 0; i < 3; i++) try {
                if (attrs && attrs[attrNames[i]]) {
                    eval("var attrsAux= " + attrs[attrNames[i]]);
                    for (var key in attrsAux) {
                        var value = attrsAux[key];
                        "boolean" == typeof value ? value && (strAttrs[i] += key + " ") : ("string" == typeof value && value.indexOf('"') > 0 && (value = value.replace(/"/g, "&quot;")), strAttrs[i] += key + '="' + value + '" ')
                    }
                }
            } catch (a) {
                console.log(a)
            }
            var html = '<select ng-model="date" ' + strAttrs[0] + ' ng-options="date.value as date.name disable when date.disabled for date in dates"></select><select ng-model="month" ' + strAttrs[1] + ' ng-options="month.value as month.name disable when month.disabled for month in months"></select><select ng-model="year" ' + strAttrs[2] + ' ng-options="year.value as year.name disable when year.disabled for year in years"></select>';
            return html
        }
    }
});